// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dda2fdbc","404":"4fa095ab","498":"e7ada470","787":"e6fbcae0"}[chunkId] + ".chunk.js";
};